import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { default as RootReducer } from './rootReducer';


export const history = createBrowserHistory()

export type RootState = ReturnType<AppStore['getState']>
export type PartialRootState = Partial<RootState>;

export const store = configureStore({
  reducer: RootReducer(history),
  devTools: process.env.NODE_ENV === 'development',
 })

export type AppStore = typeof store;
export type StoreDispatch = AppStore['dispatch'];
export type StoreGetState = typeof store.getState;

export const useAppStore = useStore.withTypes<AppStore>()

// Use throughout app instead of plain `useDispatch` and `useSelector`
// @see https://redux-toolkit.js.org/tutorials/typescript#define-typed-hooks
export const useAppDispatch = useDispatch.withTypes<StoreDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
